module.exports = __webpack_public_path__ + "static/casa-3236097fb30922dd86b6837eb8c99e20.png";